import { useIntl } from "react-intl";

const Storage = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.Storage.header",
            defaultMessage: "Storage"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.Storage.body",
            defaultMessage:
                "Confluence and products in the Jira suite all come with their own file storage space, even if you have more than one instance of the same product."
        }),
        body2: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.Storage.body2",
            defaultMessage:
                "For example, if you have two Jira Service Management instances from two sites, each has its own storage. This storage is primarily used for attachments."
        }),
        link: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.Storage.link",
                defaultMessage:
                    "<learnMore>Learn more</learnMore> about the amount of storage available by plan."
            },
            {
                learnMore: (chunk: React.ReactNode) => (
                    <a
                        href="https://confluence.atlassian.com/cloud/storage-policy-for-atlassian-cloud-products-873871367.html"
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="jiraServiceManagement"
                        data-label-english="Learn more"
                    >
                        {chunk}
                    </a>
                )
            }
        )
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
            <p>{messages.body2}</p>
            <p>{messages.link}</p>
        </>
    );
};

export default Storage;
